<div class="reset-password" *ngIf="verificationCodeForm && resetPasswordForm">
  <div *ngIf="step === 'password'">
    <p class="authentication__right__card_title">
      {{ 'LOGIN.PASSWORD_RESET.TITLE' | translate }}
    </p>

    <div class="mt-27 mb-27">
      <code-step [verificationCodeForm]="verificationCodeForm"></code-step>
    </div>

    <new-password-step
      [isLoading]="isLoading"
      [verificationCodeForm]="verificationCodeForm"
      [resetPasswordForm]="resetPasswordForm"
      [disabled]="resetPasswordForm.invalid || verificationCodeForm.invalid || isLoading"
      (resetPassword)="resetPassword()"
    ></new-password-step>
  </div>

  <div *ngIf="loginStep === 'softwareToken'" [@slideInRight]>
    <mfa-step
      [isLoading]="isLoading"
      [verificationCodeForm]="verificationCodeForm"
      (insertVerificationCode)="authWithSoftwareToken()"
      (toRecoveryCodeStep)="toRecoveryCodeStep()"
    ></mfa-step>
  </div>
</div>
